import { useState, useRef } from "react";

const useVoiceInput = (onTranscript) => {
    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);

    const startListening = () => {
        // Electron supports webkitSpeechRecognition out of the box
        const SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;
        
        if (!SpeechRecognition) {
            console.error("Speech recognition not supported in this browser.");
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN'; // Use 'mr-IN' for Marathi support
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onstart = () => setListening(true);
        
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            onTranscript(transcript); // Sends the text back to the component
        };

        recognition.onerror = (event) => {
            console.error("Speech Error:", event.error);
            setListening(false);
        };

        recognition.onend = () => setListening(false);

        recognitionRef.current = recognition;
        recognition.start();
    };

    const stopListening = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
        }
    };

    return { listening, startListening, stopListening };
};

export default useVoiceInput;